(function($) {

	$.loadComplete = function(cb) {
		var fired = false;

		function func(e) {
			// console.log(e.type);
			if (fired)
				return;

			fired = true;
			cb($);
			if (e.type == 'load')
				$(window).trigger('load');
		}

		$(document).ready(func);
		$(window).on('load', func);
	};

})(window.jQuery);
/*!
	Hash Smooth Scrolling by Daniel Flynn & Bryan Oakley

	Usage:
		Add data-anchor attributes matching a link's hash to elements on the page where you would normally put an id
		Optional:
			data-anchor-min-duration	=> Controls the minimum time to scroll (default: 250ms)
			data-anchor-max-duration	=> Controls the maximum time to scroll (default: 1000ms)
			data-anchor-speed			=> Controls the speed of the scroll (default: 1 movement of the window height in px per 250ms)
			data-anchor-easing			=> Controls the easing used for the animation (default: swing)

			These can be placed on either the link, the element, or the body with the data-anchor tag. Priority is as follows: Link, Element, Body
*/
!function(a){var n=window,t="inner";"innerWidth"in window||(t="client",n=document.documentElement||document.body);var o=0,e=!1,r=a(document),i=function(n,t,i){e=!1;var s,h;i?(s=i,h=Math.min(i.prop("scrollHeight")-i.height(),n.offset().top+i.scrollTop()-i.offset().top+t.offset)):(s=r,h=Math.min(r.height()-a(window).height(),n.offset().top+t.offset)),o=s.scrollTop();var d=0,c={x:o};t.speed&&(d=Math.abs(o-h)/t.speed*1e3,d>t.maxDuration?d=t.maxDuration:d<t.minDuration&&(d=t.minDuration)),a(c).stop().animate({x:h},{duration:d,easing:t.easing,step:function(n,t){var r=Math.floor(n);if(r!=o){if(e)return void a(c).stop();o=r,s.scrollTop(r)}}})},s=function(o){var e=a('[data-anchor="'+o.hash+'"]');if(e.length||(e=a('[data-anchor="'+o.hash.substr(1)+'"]')),e.length){var r=a(e.data("anchor-parent"));r.length||(r=e.parents(".anchor-container")),o.speed=o.speed||parseInt(e.data("anchor-speed"))||parseInt(r.data("anchor-speed"))||parseInt(a("body").data("anchor-speed"))||4*n[t+"Height"],o.minDuration=o.maxDuration||parseInt(e.data("anchor-min-duration"))||parseInt(r.data("anchor-min-duration"))||parseInt(a("body").data("anchor-min-duration"))||250,o.maxDuration=o.maxDuration||parseInt(e.data("anchor-max-duration"))||parseInt(r.data("anchor-max-duration"))||parseInt(a("body").data("anchor-max-duration"))||1e3,o.easing=o.easing||e.data("anchor-easing")||r.data("anchor-easing")||a("body").data("anchor-easing")||"swing",o.offset=o.offset||e.data("anchor-offset")||r.data("anchor-offset")||a("body").data("anchor-offset")||0,o.delay?setTimeout(function(){i(e,o,r.length?r:void 0)},o.delay):i(e,o,r.length?r:void 0)}};r.on("scroll",function(){r.scrollTop()!=o&&(e=!0)}),r.on("click",'a[href*="#"]:not([href="#"])',function(){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){var n=a(this);s({hash:this.hash,speed:parseInt(n.data("anchor-speed")),minDuration:parseInt(n.data("anchor-min-duration")),maxDuration:parseInt(n.data("anchor-max-duration")),easing:n.data("anchor-easing"),offset:n.data("anchor-offset")})}}),a(window).on("load",function(){location.hash&&s({hash:location.hash,delay:parseInt(a("body").data("anchor-load-delay"))})}),a.fn.smoothAnchor=function(a){s({hash:a})}}(jQuery);
//# sourceMappingURL=smooth-anchor.min.js.map
//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery.loadComplete(function($) {
	// Global vars
	// var windowWidth = 0,
	// windowHeight = 0,
	// $scrollTop = 0,
	// // loading = true,
	// $self, 
	// $this,
	// $window = $(window),	
	// $document = $(document),	
	// body = $('body'),
	// header = $('.header'),
	// main = $('.main'),
	// footer = $('.footer');

	/*====================================
	Window Events
	====================================*/

	// $window.resize(function(e) {
	// 	//Causes resize not to fire if the windows haven't actually changed (great for IE8)
	// 	// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
	// 	windowWidth = $window.viewportWidth();
	// 	windowHeight = $window.viewportHeight();

	// 		//Code goes here
	// 	main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );
	// 	// console.log(windowHeight);
	// 	// console.log(windowWidth);
	// 	// console.log(header.outerHeight(true));
	// 	// console.log(footer.outerHeight(true));

	// 	// }
	// }).resize();

	/*====================================
	Document Events
	====================================*/

	// $document.scroll(function(e) {
	// 	$scrollTop = $document.scrollTop();
	// 	body.toggleClass('scrolled', $scrollTop > 100);
	// 	// console.log(scrollTop);
	// });

	//stops the browser loading delay 
	// setTimeout(function() {
	// 	loading = false;
	// }, 500);



});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });